import React, { useRef, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { TweenMax } from 'gsap';

import './App.scss';
import './styles/GlobalStyles.scss';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Destinations from './components/Destinations';
import Experience from './components/Experience';
import Booking from './components/Booking';
import Testimonials from './components/Testimonials';
import Technology from './components/Technology';
import Membership from './components/Membership';
import Crew from './components/Crew';
import Safety from './components/Safety';
import Journal from './components/Journal';
import FAQ from './components/FAQ';
import Starfield from './components/Starfield';
import About from './components/About';
import Fleet from './components/Fleet';
import Footer from './components/Footer';

function App() {
  let app = useRef(null);

  useEffect(() => {
    TweenMax.to(app, 0, { css: { visibility: 'visible' } });
  }, []);

  const Home = () => (
    <>
      <Hero />
      <Destinations />
      <Technology />
      <Experience />
      <Safety />
      <Testimonials />
      <Crew />
      <Journal />
      <Membership />
      <FAQ />
      <Booking />
    </>
  );

  return (
    <Router>
      <div className="App" ref={el => app = el}>
        <Starfield />
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/fleet" component={Fleet} />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
